import React, { FC } from 'react';

import { file } from 'helpers';
import { fileService } from 'services';
import { useLang, useMutation } from 'hooks';
import { Paperclip } from 'components/icons';
import { Button, Form, Paragraph } from 'components/ui';
import { Nullish, Override } from 'types/common';
import { FormItemProps } from 'types/components';
import { UploadedFile } from 'types/models';

type ItemProps = Override<FormItemProps, {
  uploadedFile: Nullish<UploadedFile>;
}>;

const Item: FC<ItemProps> = ({ uploadedFile, ...props }) => {
  const lang = useLang();

  const downloadClientFileMutation = useMutation({
    mutationFn: fileService.downloadFile,
  });

  return (
    <Form.Item {...props}>
      {uploadedFile ? (
        <Button
          size="small"
          type="text"
          icon={<Paperclip />}
          loading={downloadClientFileMutation.isPending}
          onClick={async () => file.openFile(
            await downloadClientFileMutation.mutateAsync(uploadedFile.type),
          )}
        >
          {uploadedFile.name}
        </Button>
      ) : (
        <Paragraph type="secondary">
          {lang.get('profile.verification.emptyFile')}
        </Paragraph>
      )}
    </Form.Item>
  );
};

export default Item;
